import React from "react";
import { useNavigate } from "react-router-dom";
import { Header, Button, Avatar } from "@dishopsaas/design-system";
import { useTheme } from "@mui/material";
import { useInfoBar } from "../../../../hooks/useInfoBar";
import { useUserDropdown } from "../../../../hooks/useUserDropdown";
import { TERTIARY } from "../../../../constants/configuration";
import { AccountBar, detailsStyle } from "./TopAccountBar.styles";
import { InfoBarMobile } from "../InfoBarMobile";
import { UserDropdown } from "../UserDropdown/UserDropdown.view";
import ShopHeaderContent from "../ShopHeaderContent";
import { useResponsiveMaterial } from "../../../../hooks/useResponsive";
import { useAppSelector } from "../../../../redux/hook";
import CloseButton from "../../../CloseButton";

export const TopAccountBar = ({ isOrderTracking = false }) => {
  const navigate = useNavigate();
  const infoBar = useInfoBar();
  const theme = useTheme();
  const styles = AccountBar(theme);
  const isTablet = useResponsiveMaterial("md", "up");
  const { goToOrders } = useUserDropdown();
  if (!infoBar) return null;
  const { pendingOrderReducer, configurationReducer, shopReducer } =
    useAppSelector((s) => s);
  const { orderType } = pendingOrderReducer;
  const {
    theme: themeConfiguration,
    google,
    secondaryColor,
    orderTypes,
    loyalty,
  } = configurationReducer;
  const { openHours, addressShop, shopName } = shopReducer;
  const { name, logoUrl, nbCommande, user, points, handlers } = infoBar;

  return (
    <>
      {infoBar.isMobile ? (
        <InfoBarMobile
          {...infoBar}
          withoutAddress={true}
          isOrderTracking={isOrderTracking}
        />
      ) : isOrderTracking ? (
        <Header
          leftElement={!infoBar.isMobile && <div></div>}
          centerElement={<Avatar src={logoUrl} size="md" shape="rounded" />}
          rightElement={
            <CloseButton onClick={() => goToOrders()}></CloseButton>
          }
          containerStyle={styles.headerStyle}
          detailStyle={{
            ...detailsStyle,
            rightStyle: {
              ...detailsStyle?.rightStyle,
              gap: 0,
            },
          }}
        />
      ) : (
        <Header
          leftElement={
            <Button
              label="Revenir au menu"
              colorType={TERTIARY}
              borderRadius={8}
              leftIcon="ArrowLeft"
              size="medium"
              onClick={() => navigate("/")}
            />
          }
          centerElement={
            isTablet && (
              <ShopHeaderContent
                logoUrl={logoUrl}
                name={name}
                isTablet={isTablet}
                styles={styles}
                withContainer
                addressShop={addressShop}
                orderType={orderType}
                theme={themeConfiguration}
                googleApiKey={google.apiKey}
                secondaryColor={secondaryColor}
                orderTypes={orderTypes}
                openHours={openHours}
                shopName={shopName}
              />
            )
          }
          rightElement={
            <UserDropdown
              user={user}
              points={points}
              showDetails={isTablet}
              nbCommande={nbCommande}
              styles={styles}
              handlers={handlers}
              loyalty={loyalty}
            />
          }
          containerStyle={styles.headerStyle}
          detailStyle={{
            ...detailsStyle,
            rightStyle: {
              ...detailsStyle?.rightStyle,
              gap: 0,
            },
          }}
        />
      )}
    </>
  );
};
